import React from 'react';
import styles from '../../styles/Roommates/GroupChat.module.css';

const Message = ({ message, isOwn }) => (
  <div className={`${styles.message} ${isOwn ? styles.sentMessage : styles.receivedMessage}`}>
    <div className={styles.sender}>{message.sender}</div>
    <div>{message.content}</div>
    <div className={styles.timestamp}>{message.timestamp}</div>
  </div>
);

export default Message;
